module.exports = __webpack_public_path__ + "img/icon-pay-cancel-off-white.a908716.png";